import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookMarked, Plus } from 'lucide-react';
import classes from '../glossary.module.scss';
import { createCn } from '../../../helpers/utils';
import { GlossaryTermItem } from '../../../services/api.service';
import GlossaryRow from './glossary-row.component';

const cn = createCn('glossary', classes);

interface GlossaryListProps {
  terms: GlossaryTermItem[];
  /** Терминов в глоссарии нет вообще (а не «не найдено по фильтру»). */
  hasNoTermsAtAll: boolean;
  togglingId: number | null;
  deletingId: number | null;
  onAdd: () => void;
  onEdit: (term: GlossaryTermItem) => void;
  onDelete: (term: GlossaryTermItem) => void;
  onToggleActive: (term: GlossaryTermItem, isActive: boolean) => void;
}

const GlossaryList = ({
  terms,
  hasNoTermsAtAll,
  togglingId,
  deletingId,
  onAdd,
  onEdit,
  onDelete,
  onToggleActive,
}: GlossaryListProps) => {
  const { t } = useTranslation();

  if (terms.length === 0) {
    if (hasNoTermsAtAll) {
      return (
        <div className={cn('empty')}>
          <BookMarked size={32} className={cn('empty-icon')} strokeWidth={1.5} />
          <div className={cn('empty-title')}>{t('glossary.empty-title')}</div>
          <div className={cn('empty-hint')}>{t('glossary.empty-hint')}</div>
          <button type="button" className={cn('empty-cta')} onClick={onAdd}>
            <Plus size={16} /> {t('glossary.empty-cta')}
          </button>
        </div>
      );
    }
    return <div className={cn('empty')}>{t('glossary.empty-filtered')}</div>;
  }

  return (
    <div className={cn('list')}>
      <div className={cn('row', { header: true })}>
        <div>{t('glossary.column-term')}</div>
        <div>{t('glossary.column-description')}</div>
        <div>{t('glossary.column-language')}</div>
        <div>{t('glossary.column-aliases')}</div>
        <div>{t('glossary.column-active')}</div>
        <div>{t('glossary.column-actions')}</div>
      </div>

      {terms.map((term) => (
        <GlossaryRow
          key={term.id}
          term={term}
          togglingActive={togglingId === term.id}
          deleting={deletingId === term.id}
          onEdit={() => onEdit(term)}
          onDelete={() => onDelete(term)}
          onToggleActive={(isActive) => onToggleActive(term, isActive)}
        />
      ))}
    </div>
  );
};

export default GlossaryList;
